import React, { useState } from 'react';
import api from '../../utils/api';

const localDate = value => {
    const date = new Date(value);
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};

export default function ExternalAccessEditor({ participant, conversationId, onSaved, onCancel }) {
    const [expiry, setExpiry] = useState(() => localDate(participant.expiresAt));
    const [role, setRole] = useState(participant.role || 'contributor');
    const [shareHistory, setShareHistory] = useState(Boolean(participant.shareHistory));
    const [busy, setBusy] = useState(false);
    // A joined guest has no expiry to edit: access lasts until it is withdrawn.
    const joined = participant.status === 'active';
    const [error, setError] = useState('');
    const save = async event => {
        event.preventDefault();
        setBusy(true);
        setError('');
        try {
            await api.put(`/conversations/${conversationId}/externals/${participant._id}`, joined
                ? { role, shareHistory }
                : { expiresAt: new Date(expiry).toISOString(), role, shareHistory });
            onSaved();
        } catch (err) {
            setError(err.response?.data?.message || 'Could not update access. Check the expiry and try again.');
        } finally { setBusy(false); }
    };
    return <form className="ext-access-editor" onSubmit={save} aria-label={`Access for ${participant.name}`}>
        {joined ? <p className="ext-hint">Joined. Access lasts until it is withdrawn.</p> : <>
            <label className="ext-label">Invitation must be accepted by (your local time)
                <input className="ext-input" type="datetime-local" required value={expiry} onChange={e => setExpiry(e.target.value)} />
            </label>
            <p className="ext-hint">Move the date earlier or later, up to 90 days from today.</p>
        </>}
        <label className="ext-label">Role in this group
            <select className="ext-input" value={role} onChange={e => setRole(e.target.value)}>
                <option value="contributor">Can reply and upload</option>
                <option value="viewer">View only</option>
            </select>
        </label>
        <label className="ext-check"><input type="checkbox" checked={shareHistory} onChange={e => setShareHistory(e.target.checked)} />
            <span>Include earlier chat history<small>Otherwise, only messages since this invitation are visible. Previously viewed content cannot be taken back.</small></span>
        </label>
        {error && <p role="alert" className="portal-error">{error}</p>}
        <div className="ext-row-actions">
            <button className="msgr-btn primary" disabled={busy}>{busy ? 'Saving…' : 'Save access'}</button>
            <button type="button" className="msgr-btn" disabled={busy} onClick={onCancel}>Cancel</button>
        </div>
    </form>;
}
